import Vue from 'vue'
import Router from 'vue-router'
import Page from '@/components/Page'
import Test from '@/components/Test'
import Conditions from '@/components/ParticipationConditions'
import Boot from '@/Boot'

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Page
    },
    {
      path: '/teilnahmebedingungen',
      name: 'Conditions',
      component: Conditions
    },
    {
      path: '/:city',
      name: 'City',
      component: Page
    },

    {
      path: '/test',
      name: 'Test',
      component: Test
    },
    {
      path: '*',
      name: 'NotFound',
      component: Page
    }
  ],
  mode: 'history'
});


router.beforeEach((to, from, next) => {
  if (from.name) {
    Boot.app.showPreloader();
    setTimeout(() => {
      next();
      setTimeout(() => {
        Boot.app.hidePreloader();
      }, 500);
    }, 300);
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js